import ACS from "entity/Indicador/ACS";
import ADC from "entity/Indicador/ADC";
import ADF from "entity/Indicador/ADF";
import AH from "entity/Indicador/AH";
import AS from "entity/Indicador/AS";
import AVL from "entity/Indicador/AVL";
import AltC from "entity/Indicador/AltC";
import BA from "entity/Indicador/BA";
import Bio from "entity/Indicador/Bio";
import CM from "entity/Indicador/CM";
import EES from "entity/Indicador/EES";
import Falhas from "entity/Indicador/Falhas";
import IBF from "entity/Indicador/IBF";
import LBM from "entity/Indicador/LBM";
import LC from "entity/Indicador/LC";
import NGV from "entity/Indicador/NGV";
import PCorte from "entity/Indicador/PCorte";
import PDT from "entity/Indicador/PDT";
import PS from "entity/Indicador/PS";
import Perdas from "entity/Indicador/Perdas";
import Perf from "entity/Indicador/Perf";
import Piso from "entity/Indicador/Piso";
import PragaSolo from "entity/Indicador/PragaSolo";
import TMM from "entity/Indicador/TMM";
import TMT from "entity/Indicador/TMT";
import TTC from "entity/Indicador/TTC";
import TTP from "entity/Indicador/TTP";
import VCC from "entity/Indicador/VCC";
import Colheita from "entity/TipoIndicador/Colheita";
import ColheitaMuda from "entity/TipoIndicador/ColheitaMuda";
import Plantio from "entity/TipoIndicador/Plantio";
import Pragas from "entity/TipoIndicador/Pragas";
import TratosSoca from "entity/TipoIndicador/TratosSoca";
import MM from "entity/Indicador/MM";
import TratosPlanta from "entity/TipoIndicador/TratosPlanta";
import TAH from "entity/Indicador/TAH";
import ADH from "entity/Indicador/ADH";
import ADN from "entity/Indicador/ADN";
import UQL from "entity/Indicador/UQL";
import AFC from "entity/Indicador/AFC";
import ADO from "entity/Indicador/ADO";
import DC from "entity/Indicador/DC";
import DCor from "entity/Indicador/DCor";
import Canterizacao from "entity/TipoIndicador/Canterizacao";
import PC from "entity/Indicador/PC";
import AC from "entity/Indicador/AC";
import MPB from "entity/TipoIndicador/MPB";
import DP from "entity/Indicador/DP";
import PreparoSolo from "entity/TipoIndicador/PreparoSolo";
import ARSUB from "entity/Indicador/ARSUB";
import IPSP from "entity/Indicador/IPSP";
import EnlDesp from "entity/Indicador/EnlDesp";
import Torr from "entity/Indicador/Torr";
import PEsc from "entity/Indicador/PEsc";
import PSM from "entity/Indicador/PSM";
import IMV from "entity/Indicador/IMV";
import TC from "entity/Indicador/TC";
import PerdM from "entity/Indicador/PerdM";

export const listaIndicadores = () => {
    let indicadoresPossiveis = [];

    function addIndicadores(tipoIndicador, indicadores) {
        indicadores.map((i) => new i(tipoIndicador)).forEach((ind) => indicadoresPossiveis.push(ind));
    }

    addIndicadores(PreparoSolo, [AFC, ADF, ARSUB, IPSP, ADO, DCor, Torr]);
    addIndicadores(Plantio, [NGV, ADF, CM, EES, VCC, PS, AltC, Perdas, Piso, ADC, Falhas, PDT, TTP, Perf, AC]);
    addIndicadores(Colheita, [Perdas, PerdM, Piso, AS, IBF, ACS, TTC, TMT, TMM, Bio, IMV, TC]);
    addIndicadores(Canterizacao, [ADC, PC, ADO, AC]);
    addIndicadores(ColheitaMuda, [MM]);
    addIndicadores(MPB, [DP, ADF, EES, VCC, PS, AltC]);
    addIndicadores(TratosSoca, [AC, ADF, AFC, AH, ADH, ADN, ADC, ADO, AVL, DC, DCor, EnlDesp, PCorte, PEsc, TAH, Torr]);
    addIndicadores(TratosPlanta, [ADF, AH, TAH, ADH, ADN, AVL, UQL]);
    addIndicadores(Pragas, [LC, LBM, BA, PragaSolo, PSM]);

    return indicadoresPossiveis;
};
